import { Redo16 } from 'ui/icons';
import { ButtonProps } from 'modules/queryBuilder/contexts';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { QueryBuilderIconButton } from './QueryBuilderIconButton';

export const DATA_TEST = {
  button: 'redo-button',
};

export const RedoButton = (props: ButtonProps) => {
  const { t } = useTranslation();
  return (
    <QueryBuilderIconButton
      {...props}
      dataTest={DATA_TEST.button}
      tooltipContent={t('storybook.buttons.redo')}
      Icon={Redo16}
    />
  );
};
